import { buildService } from './decorated-service';

const BPIDService = buildService(
  '/nasu-svc/service/customer/business-party-id'
);

export const getBPId = (uberId): Promise<any> =>
  BPIDService.http.get(`/${uberId}`);
